import { Link } from 'react-router'
import barChartIcon from '/img/bar_chart.svg'
import emergencyHomeIcon from '/img/emergency_home.svg'
import encryptedIcon from '/img/encrypted.svg'
import publishedWithChangesIcon from '/img/published_with_changes.svg'
import { Button } from '#app/components/ui/button'
import { Card, CardContent } from '#app/components/ui/card'
import { Icon } from '#app/components/ui/icon'
export default function TenantScreeningRoute() {
	return (
		<div className="w-full min-h-screen overflow-hidden">
			{/* Hero Section */}
			<section className="py-12 sm:py-16 lg:py-16">
				<div className="px-[15px] md:px-[100px] mx-auto">
					<div className="text-center mb-16">
						<h1 className="text-3xl md:text-5xl lg:text-6xl font-normal font-['Futura_Hv_BT'] text-neutral-800 mb-12">
							Tenant Screening
						</h1>
						<h2 className="text-2xl md:text-3xl font-normal font-['Futura_Md_BT'] text-gray-900 mb-6 text-left mx-auto">
							Ongoing Protection For Your Rentals
						</h2>
						<p className="text-lg md:text-xl text-left lg:text-2xl font-normal font-['Futura_Bk_BT'] text-neutral-600 leading-relaxed">
							With TrueTenant, tenant screening isn't just a one-time snapshot —
							it's ongoing protection. Our system gives you continuous
							visibility into your tenants' financial health, so you're always
							prepared and never caught off guard.
						</p>
					</div>
					<hr className="border-[#CDCDCD] mt-6" />
				</div>
			</section>

			{/* Why Landlords Trust Our Formula Section */}
			<section className="py-16 lg:py-14 md:pt-0!">
				<div className="px-[15px] md:px-[100px] mx-auto">
					<div className="grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-16 items-center">
						{/* Left: Visual Graphic */}
						<div className="relative">
							<h2 className="text-xl sm:text-2xl lg:text-3xl font-normal font-['Futura_Md_BT'] text-neutral-800 mb-8">
								Why Landlords Trust Our Formula
							</h2>
							<img
								src={'/img/analytics-image1.png'}
								alt="Tenant Screening"
								className="w-full h-auto"
							/>
						</div>

						{/* Right: Feature List */}
						<div className="space-y-6 sm:space-y-8">
							<div className="justify-between flex flex-col gap-6 sm:gap-10">
								{/* Proven For 20+ Years */}
								<Card className="bg-transparent border border-[#AEAEAE] shadow-none rounded-xl">
									<CardContent className="p-4 sm:p-6">
										<div className="flex items-start gap-4">
											<div className="w-2 h-2 bg-gray-600 rounded-full mt-3 flex-shrink-0" />
											<div>
												<h3 className="text-lg sm:text-xl font-bold font-['Futura_Md_BT'] text-neutral-800 mb-2">
													Proven For 20+ Years
												</h3>
												<p className="text-sm sm:text-base text-neutral-600 font-['Futura_Bk_BT']">
													Built on a screening formula that has successfully
													identified reliable tenants for decades.
												</p>
											</div>
										</div>
									</CardContent>
								</Card>

								{/* Comprehensive Insights */}
								<Card className="bg-transparent border border-[#AEAEAE] shadow-none rounded-xl">
									<CardContent className="p-4 sm:p-6">
										<div className="flex items-start gap-4">
											<div className="w-2 h-2 bg-gray-600 rounded-full mt-3 flex-shrink-0" />
											<div>
												<h3 className="text-lg sm:text-xl font-bold font-['Futura_Md_BT'] text-neutral-800 mb-2">
													Comprehensive Insights
												</h3>
												<p className="text-sm sm:text-base text-neutral-600 font-['Futura_Bk_BT']">
													We combine past financial and rental history with
													current, verified data.
												</p>
											</div>
										</div>
									</CardContent>
								</Card>

								{/* Ongoing Soft Checks */}
								<Card className="bg-transparent border border-[#AEAEAE] shadow-none rounded-xl">
									<CardContent className="p-4 sm:p-6">
										<div className="flex items-start gap-4">
											<div className="w-2 h-2 bg-gray-600 rounded-full mt-3 flex-shrink-0" />
											<div>
												<h3 className="text-lg sm:text-xl font-bold font-['Futura_Md_BT'] text-neutral-800 mb-2">
													Ongoing Soft Checks
												</h3>
												<p className="text-sm sm:text-base text-neutral-600 font-['Futura_Bk_BT']">
													Choose quarterly, semi-annual, or annual updates to
													get alerts if a tenant's financial situation changes —
													so you can act quickly and protect your investment.
												</p>
											</div>
										</div>
									</CardContent>
								</Card>
							</div>
						</div>
					</div>
				</div>
			</section>

			{/* The TrueTenant Advantage Section */}
			<section className="py-16 lg:py-24">
				<div className="px-[15px] md:px-[100px] mx-auto">
					<div className="text-center mb-16">
						<h2 className="text-2xl sm:text-3xl lg:text-4xl font-normal font-['Futura_Hv_BT'] text-neutral-800 mb-8">
							The TrueTenant Advantage
						</h2>
					</div>

					<div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6 sm:gap-8">
						{/* Card 1: Continuous Protection */}
						<Card className="bg-white border border-[#AEAEAE] shadow-none rounded-xl text-center py-0">
							<CardContent className="p-6 sm:p-8">
								<div className="flex items-center justify-center mx-auto mb-4 sm:mb-6">
									<img
										src={encryptedIcon}
										alt="Encrypted"
										className="w-6 h-6 sm:w-8 sm:h-8 text-white"
									/>
								</div>
								<h3 className="text-lg sm:text-xl  font-['Futura_Bk_BT'] text-neutral-800 mb-4">
									Continuous protection beyond move-in
								</h3>
							</CardContent>
						</Card>

						{/* Card 2: Early Warnings */}
						<Card className="bg-white border border-[#AEAEAE] shadow-none rounded-xl text-center py-0">
							<CardContent className="p-6 sm:p-8">
								<div className="flex items-center justify-center mx-auto mb-4 sm:mb-6">
									<img
										src={barChartIcon}
										alt="Bar Chart"
										className="w-6 h-6 sm:w-8 sm:h-8 text-white"
									/>
								</div>
								<h3 className="text-lg sm:text-xl  font-['Futura_Bk_BT'] text-neutral-800 mb-4">
									Early warnings if financial circumstances shift
								</h3>
							</CardContent>
						</Card>

						{/* Card 3: Proven Results */}
						<Card className="bg-white border border-[#AEAEAE] shadow-none rounded-xl text-center py-0">
							<CardContent className="p-6 sm:p-8">
								<div className="flex items-center justify-center mx-auto mb-4 sm:mb-6">
									<img
										src={emergencyHomeIcon}
										alt="Emergency Home"
										className="w-6 h-6 sm:w-8 sm:h-8 text-white"
									/>
								</div>
								<h3 className="text-lg sm:text-xl  font-['Futura_Bk_BT'] text-neutral-800 mb-4">
									Confidence backed by decades of proven results
								</h3>
							</CardContent>
						</Card>

						{/* Card 4: Smart Decisions */}
						<Card className="bg-white border border-[#AEAEAE] shadow-none rounded-xl text-center py-0">
							<CardContent className="p-6 sm:p-8">
								<div className="flex items-center justify-center mx-auto mb-4 sm:mb-6">
									<img
										src={publishedWithChangesIcon}
										alt="Published With Changes"
										className="w-6 h-6 sm:w-8 sm:h-8 text-white"
									/>
								</div>
								<h3 className="text-lg sm:text-xl  font-['Futura_Bk_BT'] text-neutral-800 mb-4">
									Smarter decisions with data that stays up-to-date
								</h3>
							</CardContent>
						</Card>
					</div>

					<div className="mx-auto text-center mt-16 sm:mt-20">
						<Button
							asChild
							size="lg"
							className="sm:w-auto w-fit rounded-[47.80px] text-xl font-normal font-['Futura_Md_BT'] tracking-wider"
						>
							<Link
								to="/signup"
								className="flex items-center justify-center gap-4"
							>
								<div className="text-center justify-center text-white text-l font-normal font-['Futura_Md_BT']">
									Start Now
								</div>
								<Icon name="arrow-right" className="w-6 h-6" />
							</Link>
						</Button>
					</div>
				</div>
			</section>
		</div>
	)
}
